var card = {
  bg: 'white',
  display: 'flex',
  flexDirection: 'column',
  wordWrap: 'break-word',
  backgroundClip: 'border-box',
  boxShadow: 'sm',
  border: 1,
  borderStyle: 'solid',
  borderColor: 'gray.100',
  borderRadius: 'base'
};
var card$1 = card;
export { card$1 as default };